var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavSegments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8807 15.4693C14.7696 14.5643 12.1674 10.4768 13.0669 6.34028C13.9678 2.20372 18.03 -0.414601 22.1397 0.49185C26.2508 1.3969 28.8529 5.48435 27.9535 9.6195C27.054 13.7561 22.9917 16.3744 18.8807 15.4693Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.4563 10.4724C1.08561 9.95045 -0.416296 7.59171 0.102467 5.20632C0.622625 2.81952 2.96543 1.3097 5.33612 1.83168C7.7082 2.35366 9.21011 4.7124 8.68995 7.0978C8.17119 9.4846 5.82699 10.9944 3.4563 10.4724Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.53362 25.1336C4.68739 24.5064 2.88567 21.6776 3.50902 18.8137C4.13237 15.9513 6.94513 14.1384 9.78996 14.7642C12.6362 15.3914 14.4379 18.2216 13.8146 21.0841C13.1912 23.948 10.3798 25.7609 7.53362 25.1336Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavSegments);
export default __webpack_public_path__ + "static/media/nav_segments.885e3f09582450194b23a78a4b88358d.svg";
export { ForwardRef as ReactComponent };